import { dataService } from 'App';
import { FORM_MULTI_HEADERS_CONF } from 'utils/requestHelpers';

const mmsServiceUrl='/users/mms';

export function getPreviewMms() {
  return dataService.get(
    `${mmsServiceUrl}/previewMms`,
  );
}

export function uploadMms(file) {
  let form = new FormData();
  form.append("file",file);
  return dataService.post(
    `${mmsServiceUrl}/uploadMms`,form,FORM_MULTI_HEADERS_CONF
  );
}

export function removeMms() {
  return dataService.post(
    `${mmsServiceUrl}/removeMms`
  );
}



